import { forwardRef } from 'react'

import { FaqData } from '../../types'

interface FaqContentProps {
  faqData: FaqData
}

/**
 * FAQ content component
 * Displays all FAQ sections and items with proper headings and anchors
 */
export const FaqContent = forwardRef<HTMLDivElement, FaqContentProps>(
  ({ faqData }, ref) => {
    return (
      <main className="faq-content" ref={ref}>
        {faqData.categories.map((category) => (
          <section key={category.id} id={category.id} className="faq-section">
            <h2 className="faq-category-title">{category.title}</h2>

            {category.items.map((item) => (
              <div key={item.id} id={item.id} className="faq-item">
                <h3 className="faq-question">{item.question}</h3>
                <div className="faq-answer">{item.answer}</div>
              </div>
            ))}
          </section>
        ))}
      </main>
    )
  },
)

FaqContent.displayName = 'FaqContent'
